// IsrUtil.js - Cálculo del Impuesto Sobre la Renta (ISR) mexicano para 2024
// Estos son los rangos oficiales de la LISR aplicables a residentes

export const isrTableMonthly = [
  {
    limite_inferior: 0,
    limite_superior: 746.04,
    cuota_fija: 0,
    porcentaje: 0.0192,
  },
  {
    limite_inferior: 746.05,
    limite_superior: 6332.05,
    cuota_fija: 14.32,
    porcentaje: 0.064,
  },
  {
    limite_inferior: 6332.06,
    limite_superior: 11128.01,
    cuota_fija: 371.83,
    porcentaje: 0.1088,
  },
  {
    limite_inferior: 11128.02,
    limite_superior: 12935.82,
    cuota_fija: 893.63,
    porcentaje: 0.16,
  },
  {
    limite_inferior: 12935.83,
    limite_superior: 15487.71,
    cuota_fija: 1182.88,
    porcentaje: 0.1792,
  },
  {
    limite_inferior: 15487.72,
    limite_superior: 20250.00,
    cuota_fija: 1640.02,
    porcentaje: 0.1952,
  },
  {
    limite_inferior: 20250.01,
    limite_superior: 40000.00,
    cuota_fija: 2783.54,
    porcentaje: 0.2352,
  },
  {
    limite_inferior: 40000.01,
    limite_superior: 60000.00,
    cuota_fija: 7014.87,
    porcentaje: 0.2752,
  },
  {
    limite_inferior: 60000.01,
    limite_superior: 100000.00,
    cuota_fija: 12810.15,
    porcentaje: 0.3152,
  },
  {
    limite_inferior: 100000.01,
    limite_superior: 200000.00,
    cuota_fija: 25110.56,
    porcentaje: 0.3452,
  },
  {
    limite_inferior: 200000.01,
    limite_superior: 999999999,
    cuota_fija: 59618.92,
    porcentaje: 0.3752,
  },
];

export const calculateISRMonthly = (income) => {
  // Find the appropriate tax bracket
  const row = isrTableMonthly.find(
    (r) => income >= r.limite_inferior && income <= r.limite_superior
  );

  let bracket = row;
  if (!bracket) {
    // Fallback: use the last bracket if income exceeds table
    bracket = isrTableMonthly[isrTableMonthly.length - 1];
  }

  const excedente = income - bracket.limite_inferior;
  const tax = bracket.cuota_fija + excedente * bracket.porcentaje;

  return {
    tax,
    bracket: {
      limite_inferior: bracket.limite_inferior,
      limite_superior: bracket.limite_superior,
      porcentaje: (bracket.porcentaje * 100).toFixed(2),
    },
  };
};

// Convertir cualquier periodo a una base mensual (estándar mexicano)
export const toMonthly = (amount, period) => {
  switch (period) {
    case "weekly":
      return amount * 4.333;
    case "biweekly":
      return amount * 2;
    case "monthly":
    default:
      return amount;
  }
};

// Convertir impuesto mensual al periodo
export const fromMonthly = (amount, period) => {
  switch (period) {
    case "weekly":
      return amount / 4.333;
    case "biweekly":
      return amount / 2;
    case "monthly":
    default:
      return amount;
  }
};

export const calculateISR = (income, period = "weekly") => {
  const monthly = toMonthly(income, period);
  const isrResult = calculateISRMonthly(monthly);
  const isr = fromMonthly(isrResult.tax, period);

  return {
    grossMonthly: monthly,
    isrMonthly: isrResult.tax,
    isr,
    bracket: isrResult.bracket,
  };
};